import type { MivoTranslationKey } from "./ITranslation";

export type MarketCountry = "BR" | "GB" | "ES" | "DE" | "PT";

export const DEFAULT_MARKET_COUNTRY: MarketCountry = "BR";

export const MARKET_COUNTRY_STORAGE_KEY = "mivo.marketCountry";

export const MARKET_COUNTRIES: readonly MarketCountry[] = ["BR", "GB", "ES", "DE", "PT"];

export const MARKET_COUNTRY_LABELS: Record<MarketCountry, string> = {
  BR: "Brasil",
  GB: "United Kingdom",
  ES: "España",
  DE: "Deutschland",
  PT: "Portugal",
};

export function isMarketCountry(value: string | null | undefined): value is MarketCountry {
  return value != null && (MARKET_COUNTRIES as readonly string[]).includes(value);
}

export function normalizeMarketCountry(value: string | null | undefined): MarketCountry {
  return isMarketCountry(value) ? value : DEFAULT_MARKET_COUNTRY;
}

export function defaultLocaleForMarketCountry(marketCountry: MarketCountry): MivoTranslationKey {
  switch (marketCountry) {
    case "GB":
      return "en";
    case "DE":
      return "de";
    case "ES":
      return "es";
    case "BR":
    case "PT":
    default:
      return "pt-BR";
  }
}
